import React from "react";
import classnames from "classnames";

const SubmitButton = ({
    text,
    processing,
    error,
    success,
    disabled,
    onClick,
}) => {
    const defaultState = !error && !success;
    disabled = disabled;
    const classes = classnames("button", "full-width", "button-process", {
        blue: defaultState,
        "ui_arrow-right-line": defaultState,
        processing: processing,
        "error on red": error,
        green: success,
        ui_checkmark: success,
        disabled,
    });

    return (
        <button
            className={classes}
            onClick={onClick}
            type="submit"
            disabled={disabled}
        >
            <span>{text}</span>
        </button>
    );
};

export default SubmitButton;
